import axios from "axios";
import moment from "moment";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams";
import { API_DATE_FORMAT } from "../../../../app_constants";

export const SET_LOADING = "saga/clientProfileSearch/SET_LOADING";
export const FETCH_CURRENT_USER = "saga/clientProfileSearch/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/clientProfileSearch/FETCH_CURRENT_USER_SUCCESS";
export const SEARCH_CLIENTS = "saga/clientProfileSearch/SEARCH_CLIENTS";
export const SEARCH_CLIENTS_SUCCESS = "saga/clientProfileSearch/SEARCH_CLIENTS_SUCCESS";
export const SEARCH_CLIENTS_BY_FILTERS = "saga/clientProfileSearch/SEARCH_CLIENTS_BY_FILTERS";
export const TABLE_LOADING = "saga/clientProfileSearch/TABLE_LOADING";
export const SET_DATES = "saga/clientProfileSearch/SET_DATES";
export const FETCH_FILTERS_SUCCESS = "saga/clientProfileSearch/FETCH_FILTERS_SUCCESS";
export const UPDATE_FILTERS = "saga/clientProfileSearch/UPDATE_FILTERS";
export const RESET_FILTERS = "saga/clientProfileSearch/RESET_FILTERS";
export const RESET_FILTERS_SUCCESS = "saga/clientProfileSearch/RESET_FILTERS_SUCCESS";

const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  searchClients: createAction(SEARCH_CLIENTS),
  searchClientsByFilters: createAction(SEARCH_CLIENTS_BY_FILTERS),
  updateFilters: createAction(UPDATE_FILTERS),
  resetFilters: createAction(RESET_FILTERS)
};

export const {
  fetchCurrentUser,
  searchClients,
  searchClientsByFilters,
  updateDates,
  updateFilters,
  resetFilters
} = actionCreators;

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(SEARCH_CLIENTS, getClients);
  yield takeLatest(SEARCH_CLIENTS_BY_FILTERS, getClientsByFilters);
  yield takeLatest(RESET_FILTERS, reset);
}

function* getCurrentUserData(data) {
  yield put({
    type: SET_LOADING,
    payload: true
  });

  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload });
  yield put({
    type: SET_DATES,
    payload: getDatesHelper(data.payload.calendarEndDate)
  });

  yield getFilters();

  yield put({
    type: SET_LOADING,
    payload: false
  });
}

function* getFilters() {
  const params = yield getCommonApiParams();
  let res = yield call(axios.get, queryParams.apiVersion + "pages/clients/clients/filters", {
    params
  });
  yield put({ type: FETCH_FILTERS_SUCCESS, payload: res.data });
}

function getDatesHelper(calendarEndDate) {
  const startDate = moment(calendarEndDate).startOf("month").format(API_DATE_FORMAT);
  return { startDate, endDate: calendarEndDate };
}

function* getClients(payload) {
  yield put({ type: TABLE_LOADING, payload: true });

  yield put({ type: RESET_FILTERS_SUCCESS });

  const params = yield getCommonApiParams();

  try {
    const response = yield call(
      axios.get,
      queryParams.apiVersion + "pages/clients/clients/search",
      {
        params: {
          ...params,
          search: payload.payload
        }
      }
    );

    yield put({ type: SEARCH_CLIENTS_SUCCESS, payload: response });
  } catch (error) {
    console.error(error);
  }
}

function* getClientsByFilters() {
  yield put({ type: TABLE_LOADING, payload: true });

  const params = yield getCommonApiParams();

  const filters = yield select((state) => {
    let {
      profileCreatedDate,
      firstVisitDate: { startDate, endDate },
      profile_statuses,
      membership_types,
      lead_types
    } = state.clientProfilesSearch.selectedFilters;

    return {
      created_start_date: profileCreatedDate.startDate,
      created_end_date: profileCreatedDate.endDate,
      first_visit_start_date: startDate,
      first_visit_end_date: endDate,
      profile_statuses: stringify(profile_statuses),
      membership_types: stringify(membership_types),
      lead_types: stringify(lead_types)
    };
  });

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/clients/clients/filter_list",
      {
        ...params,
        filters
      }
    );

    yield put({ type: SEARCH_CLIENTS_SUCCESS, payload: response });
  } catch (error) {
    console.error(error);
  }
}

function* reset() {
  yield put({ type: RESET_FILTERS_SUCCESS });

  yield getClientsByFilters();
}

function stringify(arr) {
  return arr.map((el) => el.name).join(",");
}

function* getCommonApiParams() {
  return yield select((state) => {
    let { organization_id, short_url } = state.commonReducer.commonProps;

    return {
      organization_id: organization_id.toString(),
      short_url
    };
  });
}
